export default {
      id: "i-analytic-services-02-usage",
      viewBox: "0 0 58 100",
      url: __webpack_public_path__ + "img/sprite.svg#i-analytic-services-02",
      toString: function () {
        return this.url;
      }
    }